import { ErrorBox } from '../styles';

interface ErrorStateProps {
	error: string;
}

export default function ErrorState({ error }: ErrorStateProps) {
	return <ErrorBox>❌ {error}</ErrorBox>;
}
